<script>
import { event } from "vue-analytics";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "Login",

  mounted() {
    this.$refs.email.focus();
  },

  computed: {
    ...mapGetters("user", ["update_your_data"])
  },

  data() {
    return {
      preloader: false,
      donieCovered: false,
      error: "",
      email: "",
      password: ""
    };
  },

  methods: {
    ...mapActions("user", ["authentication"]),
    async submit() {
      this.preloader = true;

      try {
        let valid = await this.$validator.validateAll();

        if (valid) {
          await this.authentication({
            email: this.email,
            password: this.password
          });

          event("cliente", "click", "Login:login:valido");

          if (this.update_your_data)
            return this.$router.push({ name: "update-your-data" });

          let lastRoute = this.$route.params.lastRoute;

          if (lastRoute)
            return this.$router.push({
              name: lastRoute.name,
              params: lastRoute.params
            });

          return this.$router.push({ name: "purchase-flow" });
        }
      } catch (error) {
        event("cliente", "click", "Login:login:invalido");
        this.error = error;
      }

      this.preloader = false;
    }
  }
};
</script>

<template>
  <div class="container-center" @keyup.enter="submit">
    <div v-if="!donieCovered" class="donie">
      <img src="../../static/donie.svg" alt="Donie">
    </div>
    <div v-else class="donie-covered">
      <img src="../../static/donie-blindfolded.svg" alt="Donie olhos fechados">
    </div>

    <div class="box">
      <div class="logo">
        <img src="../../static/logo.svg" alt="Donamaid">
      </div>

      <div class="form-group">
        <div class="input-group">
          <input
            id="email"
            name="email"
            type="email"
            v-validate="'required|email'"
            v-model="email"
            class="with-icon icon-user mb-5"
            placeholder="seu e-mail"
            ref="email"
            autocomplete="off"
            :class="{'has-error': errors.has('email')}"
          >
          <label for="email">seu e-mail</label>

          <transition name="fade" mode="out-in">
            <div
              class="error-button"
              v-if="errors.has('email')"
              v-tooltip.left="errors.first('email')"
            >!</div>
          </transition>
        </div>
      </div>

      <div class="form-group">
        <div class="input-group">
          <input
            id="password"
            name="password"
            type="password"
            v-validate="'required'"
            v-model="password"
            class="with-icon icon-password mb-5"
            @focus="donieCovered = true"
            @blur="donieCovered = false"
            placeholder="sua senha"
            data-vv-as="senha"
            :class="{'has-error': errors.has('password')}"
          >
          <label for="password">sua senha</label>

          <transition name="fade" mode="out-in">
            <div
              class="error-button"
              v-if="errors.has('password')"
              v-tooltip.left="errors.first('password')"
            >!</div>
          </transition>
        </div>
      </div>

      <transition name="zoom" mode="out-in">
        <div v-if="error" class="error-bag">
          {{error}}
          <div @click="error = ''">x</div>
        </div>
      </transition>

      <div
        class="btn bg-purple mt-20 mb-20"
        :class="{'btn--loading': preloader}"
        @click="submit"
        tabindex="-1"
      >
        <span>entrar</span>
      </div>

      <router-link
        @click="event('cliente', 'click', 'Login:esqueciminhasenha')"
        :to="{name: 'forgot-my-password'}"
        tabindex="-1"
      >esqueci minha senha</router-link>
    </div>

    <p class="small text-gray link">
      Ainda não tem cadastro? Faça
      <router-link
        @click="event('cliente', 'click', 'Login:fazercadastro')"
        :to="{name: 'signup'}"
        tabindex="-1"
      >
        <b>aqui</b>
      </router-link>.
    </p>
  </div>
</template>

<style scoped>
#email {
  text-transform: lowercase;
}

.error-bag {
  display: inline-flex;
  background: #ffcaca;
  margin-top: 15px;
  padding: 5px 15px;
  border-radius: 4px;
  font-size: 12px;
  color: var(--pink);
}

.error-bag div {
  font-size: 10px;
  margin-left: 10px;
  cursor: pointer;
}

.form-group {
  flex-direction: column;
}

.container-center {
  position: absolute;
  background: #f6f6f6;
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.box {
  width: 350px;
  margin-top: -25px;
  padding: 50px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.donie,
.donie-covered {
  width: 440px;
  height: 200px;
  display: inherit;
  margin-top: 20px;
  z-index: 99;
}

.donie img,
.donie-covered img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
}

.logo {
  margin: 10px 0 30px 0;
  width: 100%;
  height: 60px;
}

.logo img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
}

.icon-user {
  background: url("../../static/icon_user.svg") no-repeat 10px 10px;
  background-size: 20px 20px;
}

.icon-user.has-error {
  background: url("../../static/icon_user_danger.svg") no-repeat 10px 10px;
  background-size: 20px 20px;
}

.icon-password {
  background: url("../../static/icon_password.svg") no-repeat 10px 10px;
  background-size: 20px 20px;
}

.icon-password.has-error {
  background: url("../../static/icon_password_danger.svg") no-repeat 10px 10px;
  background-size: 20px 20px;
}

@media (max-width: 768px) {
  .box {
    width: 340px;
  }

  .donie,
  .donie-covered {
    width: 440px;
  }
}

@media (max-width: 480px) {
  .box {
    width: calc(100% - 100px);
    margin-top: -25px;
    padding: 30px;
  }

  .donie,
  .donie-covered {
    width: 300px;
  }

  .logo {
    margin: 20px 0;
  }
}

@media (max-width: 320px) {
  .box {
    margin-top: -18px;
    margin-bottom: 10px;
  }

  .donie,
  .donie-covered {
    margin-top: 0;
    width: 150px;
    height: 120px;
  }

  .logo {
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue